import { useState } from "react";

import { ReactComponent as ArrowIcon } from "assets/svgs/Arrow.svg";
import BaseDropDownMenuProps, { DropdownOptionObject } from "./BaseDropDownMenuProps";

type DropdownOption = string | DropdownOptionObject;
export type DropDownMenuProps = BaseDropDownMenuProps<DropdownOption>;

const DropDownMenu = ({
    className = "",
    value = "",
    dropDownOptions = [],
    displayReverse = false,
    onSelect = (dropDownOption) => console.log(dropDownOption),
}: DropDownMenuProps) => {
    const [showMenu, setShowMenu] = useState(false);

    return (
        <div
            className={`relative flex h-6 flex-col items-center justify-start space-y-1 rounded-r3 px-2 py-1 hover:bg-black80 ${className}`}
            onClick={() => setShowMenu(!showMenu)}
        >
            <div className="flex w-full  items-center justify-between transition-all">
                <p className="text-h5 text-center">{value}</p>
                <ArrowIcon
                    className={`w-3 transition ${
                        showMenu ? (displayReverse ? "-rotate-90" : "rotate-90") : ""
                    }`}
                />
            </div>
            <ul
                className={`text-h5 absolute left-0 z-50 w-full list-none ${
                    showMenu ? "block" : "hidden"
                } ${displayReverse ? "bottom-full" : "top-full"}`}
            >
                {dropDownOptions.map((dropDownOption, id) => {
                    const optionValue =
                        typeof dropDownOption === "string" ? dropDownOption : dropDownOption.value;
                    const optionName =
                        typeof dropDownOption === "string" ? dropDownOption : dropDownOption.name;
                    return (
                        <li
                            key={id}
                            className={`flex h-6 w-full  items-center justify-start px-2  ${
                                value === optionValue
                                    ? "bg-black60 "
                                    : "bg-black90 hover:bg-black70"
                            } ${id === 0 ? "rounded-t-r3" : ""} ${
                                id === dropDownOptions.length - 1 && "rounded-b-r3"
                            }`}
                            onClick={() => onSelect(optionValue)}
                        >
                            {optionName}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default DropDownMenu;
